import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Link } from "react-router-dom";
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import HomeIcon from '@material-ui/icons/LocalDrink';
import OrderIcon from '@material-ui/icons/ViewList';
import Badge from '@material-ui/core/Badge';
import { getTotalCartQuantity } from './AddToCart';
import { CartContext } from './Context';


const styles = {
  stickToBottom: {
    width: '100%',
    position: 'fixed',
    bottom: 0,
  },
};

const AppBottomNavigation = ({ match, classes }) => {
  const [value, setValue] = useState(0);
  return (
    <CartContext.Consumer>
      {cart => (
        <BottomNavigation className={classes.stickToBottom} showLabels onChange={(event, value) => setValue(value)} value={value} color="inherit">
          <BottomNavigationAction label="Produkter" icon={<HomeIcon />} component={Link} to={`${match.url}`} />
          <BottomNavigationAction label="Varukorg" component={Link} to={`${match.url}cart`} icon={<Badge badgeContent={getTotalCartQuantity(cart)} color="primary"><ShoppingCartIcon /></Badge>} />
          <BottomNavigationAction label="Beställningar" component={Link} to={`${match.url}orders`} icon={<OrderIcon />} />
        </BottomNavigation>
      )}
    </CartContext.Consumer>
  )
}
export default withStyles(styles)(AppBottomNavigation);
